import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const getgetsingleowner = createSlice({
  name: "getsingleowner",
  initialState: {
    data: [],
    status: STATUSES.IDLE,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchgetsingleowner.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchgetsingleowner.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchgetsingleowner.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export const { setOwner, setStatus } = getgetsingleowner.actions;
export default getgetsingleowner.reducer;

export const fetchgetsingleowner = createAsyncThunk(
  "/getsingleowner/fetch",
  async ({ id }) => {
    const token = Cookies.get("token");
    const res = await axios.get(`${getBaseUrl()}/getsingleowner/${id}`, {
      headers: { Authorization: token, "x-xsrf-token": token },
    });
    let OwnerData = res.data;
    OwnerData.data.track = res.data.track;
    return OwnerData.data;
  }
);
